import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ModificarAccidentePage } from './modificar-accidente.page';

const routes: Routes = [
  {
    path: '',
    component: ModificarAccidentePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ModificarAccidentePage]
})
export class ModificarAccidentePageModule {}
